module.exports = __webpack_public_path__ + "img/be.57160833.svg";